// extracted by mini-css-extract-plugin
export default {"chart":"MiniColumn_chart__YQyGr","title":"MiniColumn_title__Xs1li"};